import { rawEmail } from 'ducks/entities/schema'

export const conversationRawEmailGraphQlResponseSchema = {
  node: rawEmail,
}
